// Pagination
export const INITIAL_FEED_ITEMS_TO_SHOW = 2;
export const INITIAL_FEED_ITEMS_TO_SHOW_WITH_PINNED = 1;

// Pinned card highlight animation
export const PINNED_CARD_HIGHLIGHT_DURATION_MS = 2000;

// Content types
export const TRADER_COMMENT_CONTENT_TYPE = "traderComment";
